import React from 'react'
import Field from '../../common/Field'
import Validator from '../../common/Validator'
import Reflux from 'reflux'
import Store from '../../../store/store'
import DatePicker from 'react-date-picker';
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import api from '../../../source/api'
import 'moment/locale/hu'
import i18 from '../../../i18'
import {Link} from "react-router-dom";

class Upload extends Reflux.Component {

    constructor(props) {
        super(props)
        this.state = {
            processing: false,
            step: props.currentStep,
            onlineszamlaToken: props.onlineszamlaToken,
            company: props.company,

            fields: {
                cashregister_ledger_number: {value: props.config.cashregister_ledger_number, error: '', role: {required: true}},
                technical_number_of_bankcard_payment: {value: props.config.technical_number_of_bankcard_payment, error: '', role: {required: true}},
                ledger_number_of_price_income: {value: props.config.ledger_number_of_price_income, error: '', role: {required: true}},
                ledger_number_of_vat_free_sales: {value: props.config.ledger_number_of_vat_free_sales, error: '', role: {required: true}},
                ledger_number_of_five_percent_vat_sales: {value: props.config.ledger_number_of_five_percent_vat_sales, error: '', role: {required: true}},
                ledger_number_of_eighteen_percent_vat_sales: {value: props.config.ledger_number_of_eighteen_percent_vat_sales, error: '', role: {required: true}},
                ledger_number_of_twentyseven_percent_vat_sales: {value: props.config.ledger_number_of_twentyseven_percent_vat_sales, error: '', role: {required: true}},
                job_number: {value: props.config.job_number, error: '', role: {required: false}},
                job_number_name: {value: props.config.job_number_name, error: '', role: {required: false}},
                file: {value: '', error: '', role: {required: false}},
                preload_ap_numbers: {value: props.config.preload_ap_numbers, error: '', role: {required: false}},
                ap_number: {value: props.config.ap_number, error: '', role: {required: false}},
                skip_bank_card_items: {value: props.config.skip_bank_card_items, error: '', role: {required: false}}
            },
            startDate: new Date(),
            endDate: new Date(),
        }
        this.store = Store
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        moment.locale('hu')
    }

    startDataProcessing = (useApi) => {
        const form = this.buildSubmitForm(useApi);

        api.postFile('cashregister/steps/upload', form)
            .then((response) => {
                this.setState({processing: false})
                this.props.setOutputFiles(response.data)
                this.props.setNextStep()
            })
            .catch((err) => {
                this.setState({processing: false})

                if (err.response && err.response.status === 422) {
                    this.props.notifyError(err.response.data.message)
                    return;
                }
                this.props.notifyError('Kérjük ellerőrizze a könyvelt időszakot és a bementi fájl kiterjesztését és méretét.')
            })
    }

    buildSubmitForm = (useApi) => {
        let form = new FormData()
        let file = document.querySelector('#file')

        form.append('useApi', useApi ? 1 : 0);
        if (!useApi) {
            form.append('file', file.files[0])
        }
        form.append('start_date', moment(this.state.startDate).format('YYYY-MM-DD'))
        form.append('end_date', moment(this.state.endDate).format('YYYY-MM-DD'))
        form.append('company_id', this.state.company.id)
        form.append('cashregister_ledger_number', this.state.fields.cashregister_ledger_number.value)
        form.append('technical_number_of_bankcard_payment', this.state.fields.technical_number_of_bankcard_payment.value)
        form.append('ledger_number_of_price_income', this.state.fields.ledger_number_of_price_income.value)
        form.append('job_number', this.state.fields.job_number.value)
        form.append('job_number_name', this.state.fields.job_number_name.value)
        form.append('preload_ap_numbers', this.state.fields.preload_ap_numbers.value)
        form.append('ap_number', this.state.fields.ap_number.value)
        form.append('ledger_number_of_vat_free_sales', this.state.fields.ledger_number_of_vat_free_sales.value)
        form.append('ledger_number_of_five_percent_vat_sales', this.state.fields.ledger_number_of_five_percent_vat_sales.value)
        form.append('ledger_number_of_eighteen_percent_vat_sales', this.state.fields.ledger_number_of_eighteen_percent_vat_sales.value)
        form.append('ledger_number_of_twentyseven_percent_vat_sales', this.state.fields.ledger_number_of_twentyseven_percent_vat_sales.value)
        form.append('skip_bank_card_items', this.state.fields.skip_bank_card_items.value)
        return form
    }

    handleStartDateChange = (date) => {
        this.setState({
            startDate: date
        });
    }

    handleEndDateChange = (date) => {
        this.setState({
            endDate: date
        });
    }

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value
        fields[name].error = error
        this.setState({fields: fields})
    }

    onElementChange = (event) => {
        event.preventDefault();
        this.setValue(event.target.attributes.name.nodeValue, event.target.value);
    };

    nextStep = (useApi) => {

        let fields = this.state.fields;
        fields = Validator.reset(fields);
        fields.file.role.required = !useApi;
        fields.ap_number.role.required = useApi;
        let validator = Validator.validate(fields)

        if (validator.error) {
            this.setState({
                error: validator.error,
                fields: validator.fields,
            })
            return;
        }

        this.setState({processing: true});
        this.startDataProcessing(useApi);
    }

    render() {
        return (
            <div className='col-10 offset-1'>
                <h4 className='text-left'>Kiválasztott cég: {this.state.company.name} (<Link to='/' className='link-color'>cég csere</Link>)</h4>
                <br/>
                <div className='row'>
                    <div className='col-md-3'>
                        <p> Könyvelt időszak:</p>
                    </div>
                    <div className='col-md-3'>
                        <DatePicker
                            className="date-picker"
                            value={this.state.startDate}
                            onChange={this.handleStartDateChange}
                            required={true}
                            showLeadingZeros={true}
                        />
                    </div>
                    <div className='col-md-1'></div>
                    <div className='col-md-3'>
                        <DatePicker
                            className="date-picker"
                            value={this.state.endDate}
                            onChange={this.handleEndDateChange}
                            required={true}
                            showLeadingZeros={true}
                        />
                    </div>
                </div>

                <table className='table table-striped table-aibook-bordered'>
                    <tbody>
                    <tr>
                        <td>Pénztár főkönyvi száma *</td>
                        <td>
                            <Field
                                type='text'
                                id='cashregister_ledger_number'
                                name='cashregister_ledger_number'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Bankkártyafizetés technikai főkönyvi száma *</td>
                        <td>
                            <Field
                                type='text'
                                id='technical_number_of_bankcard_payment'
                                name='technical_number_of_bankcard_payment'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Árbevtelkarton főkönyvi száma *</td>
                        <td>
                            <Field
                                type='text'
                                id='ledger_number_of_price_income'
                                name='ledger_number_of_price_income'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Fizetendő áfa főkönyvi száma 0% értékesítés esetén *</td>
                        <td>
                            <Field
                                type='text'
                                id='ledger_number_of_vat_free_sales'
                                name='ledger_number_of_vat_free_sales'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Fizetendő áfa főkönyvi száma 5% értékesítés esetén *</td>
                        <td>
                            <Field
                                type='text'
                                id='ledger_number_of_five_percent_vat_sales'
                                name='ledger_number_of_five_percent_vat_sales'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Fizetendő áfa főkönyvi száma 18% értékesítés esetén *</td>
                        <td>
                            <Field
                                type='text'
                                id='ledger_number_of_eighteen_percent_vat_sales'
                                name='ledger_number_of_eighteen_percent_vat_sales'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Fizetendő áfa főkönyvi száma 27% értékesítés esetén *</td>
                        <td>
                            <Field
                                type='text'
                                id='ledger_number_of_twentyseven_percent_vat_sales'
                                name='ledger_number_of_twentyseven_percent_vat_sales'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Munkaszám</td>
                        <td>
                            <Field
                                type='text'
                                id='job_number'
                                name='job_number'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    {this.state.company.accountant_program_id === 1
                        ? <tr>
                            <td>Munkaszám neve</td>
                            <td>
                                <Field
                                    type='text'
                                    id='job_number_name'
                                    name='job_number_name'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                        </tr>
                        : null
                    }
                    <tr>
                        <td>Bankkártyás tételek kihagyása</td>
                        <td>
                            <select value={this.state.fields.skip_bank_card_items.value}
                                    name='skip_bank_card_items'
                                    id='skip_bank_card_items'
                                    onChange={(event) => this.onElementChange(event)}
                                    className='control-label  form-control'
                                    style={{maxWidth: "150px"}}
                            >
                                <option value="0">Nem</option>
                                <option value="1">Igen</option>
                            </select>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div className='row'>
                    <div className='col-6 text-center'>
                        <label htmlFor='file' className='control-label'>
                            Pénztárgép ZIP (.p7b állományból)<br/>
                            vagy NAV export Excel file<br/><br/>
                        </label>
                        <Field
                            type='file'
                            id='file'
                            name='file'
                            fileUploadEndpoint=''
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%', marginBottom: '20px'}}
                        />
                        <a onClick={() => this.nextStep(false)} className={this.state.processing ? 'disabled next-step' : 'next-step'} style={{display: 'inline-block', margin: '10px 0'}}>
                            {this.state.processing ? i18.BUTTONS._processing : i18.BUTTONS._startProcessing}
                        </a>
                    </div>
                    <div className='col-6 text-center' style={{marginBottom: '50px'}}>
                        <p>API alapú számla feldolgozás</p>
                        <div className='next-step-btn-container'>
                            {this.state.onlineszamlaToken
                                ? <div>
                                    <div className='row' style={{marginBottom: '20px'}}>
                                        <div className='col-5'>
                                            <label htmlFor="legal_title" className="margin-top-10 margin-bottom-2 control-label" style={{marginTop: '4px', textAlign: 'right'}}>AP szám</label>
                                        </div>
                                        <div className='col-7' style={{textAlign: 'left'}}>
                                            <Field
                                                type='text'
                                                id='ap_number'
                                                name='ap_number'
                                                label=''
                                                classLabel='control-label'
                                                classInput='bordered-input'
                                                setValue={this.setValue.bind(this)}
                                                state={this.state}
                                                style={{width: '100%'}}
                                            />
                                        </div>
                                    </div>
                                    <a onClick={() => this.nextStep(true)} className='next-step'>{this.state.processing ? i18.BUTTONS._processing : i18.BUTTONS._goToAccountAssignment}</a>
                                </div>
                                : <div>
                                    <p className="text-center">
                                        Jelenleg nincs beállítva az Onlineszamla API kapcsolat.<br/>
                                        <Link to={`/company/onlineszamla/${this.state.company.id}`} className='link-color'>Kattintson IDE a beállításhoz!</Link>
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Upload


// WEBPACK FOOTER //
// ./src/components/cashregister/steps/upload.js